module.exports = __webpack_public_path__ + "media/get-jinxed-jinx-music-video-league-of-legends.c0f9d815.mp3";